<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white rounded border">
      <dropdown v-if="this.$slots.default" class="px-4 md:px-6 rounded-l border-r hover:bg-grey-100 focus:border-white focus:shadow-outline focus:z-10" placement="bottom-start">
        <div class="flex items-center">
          <span class="text-grey-darkest hidden md:inline">Filter</span>
          <i class="fad fa-chevron-down ml-1"></i>
        </div>

        <div slot="dropdown" class="mt-2 px-4 py-6 w-screen shadow-lg bg-white rounded" :style="{ maxWidth: `${maxWidth}px` }">
          <slot />
        </div>
      </dropdown>

      <input
        class="relative w-full px-6 py-3 focus:shadow-outline"
        :class="this.$slots.default ? 'rounded-r' : 'rounded'"
        autocomplete="off"
        type="text"
        name="search"
        placeholder="Search…"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
    </div>

    <button class="ml-3 text-sm text-teal-800 hover:text-teal-900 focus:underline" type="button" @click="$emit('reset')">Reset</button>
  </div>
</template>

<script>
import Dropdown from "@/admin/Shared/Dropdown";

export default {
  components: {
    Dropdown
  },
  props: {
    value: String,
    maxWidth: {
      type: Number,
      default: 300
    }
  }
};
</script>
